module.exports = __webpack_public_path__ + "static/media/8_2.86c6bcb4.jpg";